























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductHistory } from '@/types';
import RepairIconBig from '@/assets/icons/icn-repair-big.svg';
import RepairIconSmall from '@/assets/icons/icn-repair.svg';
import ClockIcon from '@/assets/icons/icn-clock.svg';
import SendIcon from '@/assets/icons/icn-send.svg';
import SettingsIcon from '@/assets/icons/icn-settings.svg';

@Component({
  components: {
    RepairIconBig,
    RepairIconSmall,
    ClockIcon,
    SendIcon,
    SettingsIcon,
  },
})
export default class ProductHistoryRow extends Vue {
  @Prop() public history: ProductHistory;
  @Prop() public isHistoryDisplayed: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProductHistory/ProductHistory.vue